// Written by Codex on 2026-10-19
// User prompt: Show employee messages in HR notifications and keep audiences distinct.
const HR_TYPES = new Set(['new_leave_request', 'case_message_hr', 'accommodation_response_hr', 'case_message_employee']);
const EMPLOYEE_EXCLUDED = new Set(['new_leave_request', 'case_message_hr', 'accommodation_response_hr']);
export function filterNotificationsByRole(notifications, role) {
  if (role === 'super-admin') return [];
  return notifications.filter(notification => role === 'hr' ? HR_TYPES.has(notification.type) : !EMPLOYEE_EXCLUDED.has(notification.type));
}
